import React, { Fragment } from 'react';
import { string } from 'prop-types';
import { toUrl } from 'util/link';
import Head from 'next/head';

function AmpYoutubeEmbed({ url }) {
  // extract Youtube ID from url
  const parsed = toUrl(url);
  const youtubeId = parsed.pathname.match(/([^/]+)\/?$/)[1];
  return (
    <Fragment>
      <Head>
        <script
          async
          custom-element="amp-youtube"
          key="amp-youtube"
          src="https://cdn.ampproject.org/v0/amp-youtube-0.1.js"
        />
      </Head>
      <amp-youtube
        data-videoid={youtubeId}
        layout="responsive"
        width="16"
        height="9"
      />
    </Fragment>
  );
}

AmpYoutubeEmbed.propTypes = {
  url: string
};

AmpYoutubeEmbed.defaultProps = {
  url: undefined
};

export default AmpYoutubeEmbed;
